import { usePathname, useRouter, useSearchParams } from 'next/navigation.js';
import { type SectionType } from '../enums/mediaTypes.ts';
import { type ActiveMediaTypeParams } from '../types.ts';

export const useActiveReviewsDrawerParams = (): [
  ActiveMediaTypeParams | undefined,
  (params: ActiveMediaTypeParams | undefined) => void,
] => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const reviewsMediaTypeId = searchParams.get('reviewsMediaTypeId');
  // searchParams.get does not support generics
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  const reviewsMediaType = searchParams.get('reviewsMediaType') as SectionType | undefined;

  const params =
    reviewsMediaTypeId && reviewsMediaType ? { id: reviewsMediaTypeId, type: reviewsMediaType } : undefined;

  const setParams = (newParams: ActiveMediaTypeParams | undefined) => {
    const newSearchParams = new URLSearchParams(searchParams.toString());

    if (newParams) {
      newSearchParams.append('reviewsMediaTypeId', String(newParams.id));
      newSearchParams.append('reviewsMediaType', newParams.type);
    } else {
      newSearchParams.delete('reviewsMediaTypeId');
      newSearchParams.delete('reviewsMediaType');
    }

    if (newSearchParams.size > 0) {
      router.push(`${pathname}?${newSearchParams.toString()}`, { scroll: false });
    } else {
      router.push(pathname, { scroll: false });
    }
  };

  return [params, setParams];
};
